export default __webpack_public_path__ + "static/media/b3.a3a11a7f.jpg";